import { render, staticRenderFns } from "./PmtaRelayForm.vue?vue&type=template&id=30b6158c&scoped=true"
import script from "./PmtaRelayForm.vue?vue&type=script&lang=js"
export * from "./PmtaRelayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b6158c",
  null
  
)

export default component.exports